/* eslint-disable react/jsx-sort-props */
import { navigate } from 'gatsby'
import React from 'react'

import { ContentCard, CtaButton } from '../../components'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
import { defaultLanguage } from '../../utils/appConfig'
import { ALLOWED_WORDS, replaceWordInString } from '../../utils/helpers'
import {
  backgroundFallBack,
  cardContainer,
  cardExtraClassName,
  cardWidth,
  headercontainer,
} from './CategoryListing.module.css'

const CategoryListing = ({ lang, slice }) => {
  const {
    categorylinklabel,
    categorylistingcontent,
    categorylistingheader,
    categorylistingtreatments,
  } = slice

  return (
    <SectionLayout
      heading={categorylistingheader}
      renderedContent={categorylistingcontent}
      withHeader
      extraHeaderClassName={headercontainer}
      extraClassName={backgroundFallBack}
    >
      <div className={cardContainer}>
        {categorylistingtreatments &&
          categorylistingtreatments.nodes.map((treatment, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className={cardExtraClassName}>
                <ContentCard
                  title={replaceWordInString(
                    treatment.treatmentfeatureddata.featuredname,
                    'botox',
                    ALLOWED_WORDS[lang],
                  )}
                  content={replaceWordInString(
                    treatment.treatmentfeatureddata.description,
                    'botox',
                    ALLOWED_WORDS[lang],
                  )}
                  image={treatment.treatmentfeatureddata.image}
                  extraClassName={cardWidth}
                  url
                  setImageHeight
                  urlTarget={
                    lang === defaultLanguage.slice(0, 2)
                      ? `/${treatment.pageType.uri}`
                      : `/${lang.slice(0, 2)}/${treatment.pageType.uri}/`
                  }
                />
                <CtaButton
                  onClick={() =>
                    navigate(
                      lang === defaultLanguage.slice(0, 2)
                        ? `/${treatment.pageType.uri}`
                        : `/${lang.slice(0, 2)}/${treatment.pageType.uri}/`,
                    )
                  }
                  title={categorylinklabel}
                  type="transparent"
                />
              </div>
            )
          })}
      </div>
    </SectionLayout>
  )
}

export default CategoryListing
